/* towsons-whatsapp.js — the "Chat on WhatsApp" button (snippets/towsons-whatsapp; Philip, 6 Oct 2026: "a WhatsApp
 * button so that customers can start a conversation with our CS team").
 *
 * The snippet is rendered in the <head> (the loader's place on any theme), so the button is made here and put in
 * the page once it is there: a wa.me link to the shop's number, with the greeting and what the visitor was looking
 * at as the first message. Outside the hours the team answers in, a note says so — the button still works,
 * WhatsApp keeps the message. Nothing is sent anywhere from this file; no consent is needed.
 * Nothing names a shop: the number, words and hours come from the script tag's data (the shop's own config).
 *
 * Where it shows (Philip, 7 Oct 2026: "other places to put the whatsapps chat link, eg in the main menu or even header
 * etc"): the floating button where the snippet says (data-float — a snippet from before says nothing: the button);
 * a line under "Add to basket" (data-line); the header's icon where the theme has no spot rendered for it (Dawn's
 * header icons; WeDoMugs's header renders snippets/towsons-whatsapp-link); and every link to the shop's number in the
 * page — the header's, the menus' (the portal writes those) — opens with the same first message as the button.
 */
(function () {
  'use strict';
  if (window.__twWhatsapp) return;
  window.__twWhatsapp = true;
  var me = document.currentScript || document.querySelector('script[data-tw-whatsapp]');
  if (!me) return;
  var d = me.dataset || {};
  var number = String(d.number || '').replace(/\D/g, '');
  if (!number) return;
  var label = d.label || 'Chat on WhatsApp';
  var text = [d.text || '', d.about ? 'About: ' + d.about : ''].filter(Boolean).join('\n');
  var HREF = 'https://wa.me/' + number + '?text=' + encodeURIComponent(text);
  var FLOAT = d.float === undefined ? true : d.float === '1';
  var LINE = d.line === '1';
  var HEAD = d.header === '1';
  var LINK_LABEL = d.linkLabel || 'Chat with us';
  var LINE_LABEL = d.lineLabel || 'Questions? Chat with us on WhatsApp';
  var hours = null;
  try { hours = d.hours && d.hours !== 'null' ? JSON.parse(d.hours) : null; } catch (e) { hours = null; }
  // WhatsApp's glyph (Simple Icons, CC0).
  var ICON = '<svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true" focusable="false"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>';

  // Whether the team is answering now, by the shop's own clock. No hours set: always.
  function open(h, now) {
    if (!h || !h.from || !h.to) return true;
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-GB', { timeZone: h.zone || 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(now || new Date());
    } catch (e) { return true; }
    var get = function (t) { var p = parts.filter(function (x) { return x.type === t; })[0]; return p ? p.value : ''; };
    var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday'));
    var hm = (get('hour') === '24' ? '00' : get('hour')) + ':' + get('minute');
    if (Array.isArray(h.days) && h.days.length && h.days.indexOf(day) < 0) return false;
    return hm >= h.from && hm < h.to;
  }

  function mount() {
    if (!FLOAT || document.querySelector('.tw-wa')) return;
    var a = document.createElement('a');
    a.className = 'tw-wa tw-mod';
    a.href = HREF;
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', label);
    a.setAttribute('data-tw-whatsapp-button', '');
    a.innerHTML = ICON;
    var span = document.createElement('span');
    span.className = 'tw-wa__label';
    span.textContent = label;
    a.appendChild(span);
    if (hours && !open(hours)) {
      a.classList.add('is-away');
      var note = document.createElement('span');
      note.className = 'tw-wa__note';
      note.textContent = hours.away || 'We’re away just now — send your message and we’ll reply when we’re back.';
      a.appendChild(note);
    }
    document.body.appendChild(a);
  }
  function linkTo(cls) {
    var a = document.createElement('a');
    a.className = cls + ' tw-mod';
    a.href = HREF;
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('data-tw-wa-link', '');
    a.innerHTML = ICON;
    return a;
  }
  // Under "Add to basket": Warehouse's buy buttons, Dawn's, else the basket form itself. A card, not a footnote (Philip,
  // 7 Oct 2026: "The questions line, I think it gets hidden to much?"): the icon on the shop's WhatsApp colour, its
  // words, and whether the team is there now (the hours, as on the button).
  var AWAY = 'We’re away just now — send your message and we’ll reply when we’re back.';
  function mountLine() {
    if (!LINE || document.querySelector('.tw-wa-line')) return;
    // (Horizon: after its buy-buttons block — the first /cart/add form there is the instalments' line, under the price)
    var spot = document.querySelector('.product-form__buy-buttons') || document.querySelector('.product-form__buttons') || document.querySelector('.buy-buttons-block') || document.querySelector('form[action*="/cart/add"]');
    if (!spot || !spot.parentNode) return;
    var a = linkTo('tw-wa-line');
    a.innerHTML = '<span class="tw-wa-line__ico" aria-hidden="true">' + ICON + '</span><span class="tw-wa-line__txt"><span class="tw-wa-line__t"></span><span class="tw-wa-line__s"></span></span><span class="tw-wa-line__go" aria-hidden="true">›</span>';
    a.querySelector('.tw-wa-line__t').textContent = LINE_LABEL;
    var away = !!(hours && !open(hours));
    a.querySelector('.tw-wa-line__s').textContent = away ? (hours.away || AWAY) : 'Message us — we’re happy to help.';
    if (away) a.classList.add('is-away');
    spot.parentNode.insertBefore(a, spot.nextSibling);
  }
  // The header's icon, where the theme rendered no spot of its own for it: Dawn's (and its kin's) header icons; Horizon's
  // header actions (after the Rude switch, before the account — Warehouse's order).
  function mountHeader() {
    if (!HEAD || document.querySelector('[data-tw-wa-header]')) return;
    var icons = document.querySelector('.header__icons');
    var horizon = !icons && document.querySelector('header-actions');
    if (!icons && !horizon) return;
    var a = linkTo(horizon ? 'tw-wa-hd header-actions__action' : 'tw-wa-hd header__icon link');
    a.setAttribute('data-tw-wa-header', '');
    a.setAttribute('aria-label', LINK_LABEL + ' on WhatsApp');
    if (horizon) { var rude = horizon.querySelector('.tw-rude-holder'); horizon.insertBefore(a, rude ? rude.nextSibling : horizon.firstChild); return; }
    icons.insertBefore(a, icons.firstChild);
  }
  // Every link to the shop's number already in the page — the header's, the menus' — opens like the button. One that
  // says what its message is (data-tw-wa-text: the Help Centre's, which starts with the question being read) keeps it.
  function links() {
    var all = document.querySelectorAll('a[data-tw-wa-link], a[href*="wa.me/' + number + '"], a[href*="api.whatsapp.com/send?phone=' + number + '"]');
    Array.prototype.forEach.call(all, function (a) {
      if (a.classList.contains('tw-wa')) return;
      var own = a.getAttribute('data-tw-wa-text');
      a.href = own ? 'https://wa.me/' + number + '?text=' + encodeURIComponent(own) : HREF;
      a.target = '_blank';
      a.rel = 'noopener';
    });
  }
  function start() { mount(); mountLine(); mountHeader(); links(); }
  if (typeof module === 'object' && module && module.exports) module.exports = { open: open };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
